import type { StepConfig } from "@portal/components/multiform/types";
import type { BondRequestCreateFormData } from "../../schema";
import { AdditionalInfoStep } from "./AdditionalInfoStep";
import { AdditionalInfoSummary } from "./AdditionalInfoSummary";

export const additionalInfoStepConfig: StepConfig<BondRequestCreateFormData> = {
	name: "additionalInfo",
	label: "Additional Info",
	fieldPaths: ["quote.additionalInfo.comment", "quote.additionalInfo.attachments"],
	component: AdditionalInfoStep,
	summaryComponent: AdditionalInfoSummary,
};
